import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
import CommonStructured from "../../components/common-components/CommonStructured";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import AddSubscription from "./AddSubscription";
import SubscriptionUserDetails from "./SubscriptionUserDetails";
import { addNewSubscription } from "../../redux/reducers/postApiSlice";
import moment from "moment";
import { aggrementLink } from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { isAprovalAllowedEmail } from "../../components/common-data/Accessibles";
import { isDev } from "../../components/common-data/Commons";
import { isManagerRole as checkIsManagerRole } from "../../components/common-data/Conversions";
import CashVerificationQR from "../../components/payment-link-system/CashVerificationQR";

const SubscriptionPageStructure = ({
  decryptedText,
  onClickReset,
  callSubscription,
}) => {
  const dispatch = useDispatch();
  const isAdmin = decryptedText?.account_type === "admin";
  const isManagerRole = checkIsManagerRole(decryptedText);
  const isSubAddEdit = isDev || isAprovalAllowedEmail(decryptedText?.email);

  // const isSubAddEdit =
  //   decryptedText?.email === "vishal@wtfup.me" ||
  //     decryptedText?.email === "arpit@wtfup.me" ||
  //     decryptedText?.email === "naresh.kukreti@wtfup.me" ||
  //     decryptedText?.email === "chetan.sharma@wtfgyms.com"
  //     ? true
  //     : false;

  const initialCreateSubsFormData = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: decryptedText?.gym_name || "",
          value: decryptedText?.gym_id || "",
        }
      : "",
    selectedUser: "",
    selSourceName: "",
    selectedType: "",
    selectedPlan: "",
    selectedSession: "",
    enteredPrice: "",
    selectedTrxMode: "",
    enteredTrxId: "",
    cashAmount: "",
    onlineAmount: "",
    installment1Amount: "",
    installment1Date: "",
    installment1Mode: "",
    installment2Amount: "",
    installment2Date: "",
    installment3Amount: "",
    installment3Date: "",
    enteredStartDate: "",
    enteredExpireDate: "",
    extendDays: "",
    paymentDate: "",
    selectedSlotID: "",
    enteredSlotDate: "",
    selectedSlotIndex: "",
    enteredSlotStartTime: "",
    enteredSlotEndTime: "",
    trainerExpLvl: "",
    selectedTrainer: "",
    isPT: 0,
  };
  const [createSubsFormData, setCreateSubsFormData] = useState(
    initialCreateSubsFormData
  );
  const [createSubsFormErrors, setCreateSubsFormErrors] = useState({});
  const initialGstTableValues = {
    amount: "",
    taxableAmount: "",
    sgst: "",
    cgst: "",
    totalAmount: "",
    taxAmount: "",
  };
  const [gstTableValues, setGstTableValues] = useState(initialGstTableValues);
  const [createSubsModal, setCreateSubsModal] = useState(false);
  const [isSubsFormTrue, setIsSubsFormTrue] = useState(false);
  const [showUserInfoForm, setShowUserInfoForm] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [cashDraftId, setCashDraftId] = useState(null);
  const [showCashQR, setShowCashQR] = useState(false);
  const [pendingCashUserData, setPendingCashUserData] = useState(null);
  // Prevents double-click on "Add Subscription" button
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onCloseModal = () => {
    setCreateSubsModal(false);
    setShowUserInfoForm(false);
    setCurrentStep(1);
    setCreateSubsFormData(initialCreateSubsFormData);
  };

  const onCloseUserInfoModal = () => {
    setShowUserInfoForm(false);
    setShowCashQR(false);
    setCashDraftId(null);
    setPendingCashUserData(null);
    setCurrentStep(1);
    setCreateSubsFormData(initialCreateSubsFormData);
  };

  const onOpenSubscriptionModal = () => {
    setShowUserInfoForm(true);
    setCurrentStep(1);
  };

  const onClickSubmit = (e) => {
    e.preventDefault();

    setCreateSubsFormErrors(validateSubscriptionForm(createSubsFormData));
    setIsSubsFormTrue(true);
  };

  const validateSubscriptionForm = (createSubsFormData) => {
    let errors = {};

    if (!createSubsFormData.selectedGym) {
      errors.selectedGym = "Gym id required!";
    }

    if (!createSubsFormData.selectedUser) {
      errors.selectedUser = "User id required!";
    }

    if (!createSubsFormData.selectedType) {
      errors.selectedType = "Subscription type id required!";
    }

    if (
      createSubsFormData.selectedType?.value === "regular" &&
      !createSubsFormData.selSourceName
    ) {
      errors.selSourceName = "required!";
    }

    if (createSubsFormData.selectedType && !createSubsFormData.selectedPlan) {
      errors.selectedPlan = "Plan required!";
    }

    const validationTypeVal = createSubsFormData.selectedType?.value;
    const validationIsAddonLike =
      validationTypeVal === "addon" || validationTypeVal === "addon_pt";

    if (
      validationIsAddonLike &&
      createSubsFormData.selectedPlan &&
      !createSubsFormData.selectedSession
    ) {
      errors.selectedSession = "Session id required!";
    }

    if (
      validationIsAddonLike &&
      createSubsFormData.selectedPlan &&
      !createSubsFormData.selectedTrainer
    ) {
      errors.selectedTrainer = "Trainer is required!";
    }

    if (validationIsAddonLike && !createSubsFormData.enteredSlotDate) {
      errors.enteredSlotDate = "Slot date is required!";
    }

    // Backend generates virtual trainer shift intervals with an empty
    // slot_id; the real slot_master row is created server-side in
    // createDynamicSlots at subscription creation time. So we accept either a
    // real slot_id, OR a selected slot index (which implies start/end time
    // were captured and backend will build the slot on its own).
    if (
      validationIsAddonLike &&
      createSubsFormData.selectedTrainer &&
      !createSubsFormData.selectedSlotID &&
      createSubsFormData.selectedSlotIndex !== 0 &&
      !createSubsFormData.selectedSlotIndex
    ) {
      errors.selectedSlotID = "Please select a slot!";
    }

    if (!createSubsFormData.selectedTrxMode) {
      errors.selectedTrxMode = "Payment mode required!";
    }

    if (
      createSubsFormData.selectedTrxMode?.value === "online" &&
      !createSubsFormData.enteredTrxId
    ) {
      errors.enteredTrxId = "Transaction id required!";
    }

    const trxModeVal = createSubsFormData.selectedTrxMode?.value;
    if (trxModeVal === "dual") {
      const cash = parseFloat(createSubsFormData.cashAmount) || 0;
      const online = parseFloat(createSubsFormData.onlineAmount) || 0;
      const total = parseFloat(createSubsFormData.enteredPrice) || 0;

      if (!createSubsFormData.cashAmount) {
        errors.cashAmount = "Cash amount required!";
      }
      if (!createSubsFormData.onlineAmount) {
        errors.onlineAmount = "Online amount required!";
      }
      if (online > 0 && !createSubsFormData.enteredTrxId) {
        errors.enteredTrxId = "Transaction id required!";
      }
      if (cash < 0 || online < 0) {
        errors.cashAmount = errors.cashAmount || "Amounts cannot be negative!";
      }
      if (cash + online !== total) {
        errors.onlineAmount = `Cash + Online must equal ${total}`;
      }
    }
    if (trxModeVal === "partial") {
      // Partial payment now supports max 2 installments only
      const i1 = parseFloat(createSubsFormData.installment1Amount) || 0;
      const i2 = parseFloat(createSubsFormData.installment2Amount) || 0;
      const total = parseFloat(createSubsFormData.enteredPrice) || 0;

      if (!createSubsFormData.installment1Amount) {
        errors.installment1Amount = "1st installment amount required!";
      }
      if (!createSubsFormData.installment1Date) {
        errors.installment1Date = "1st installment date required!";
      }
      if (!createSubsFormData.installment2Amount) {
        errors.installment2Amount = "2nd installment amount required!";
      }
      if (!createSubsFormData.installment2Date) {
        errors.installment2Date = "2nd installment due date required!";
      }
      if (i1 <= 0 || i2 <= 0) {
        errors.installment1Amount =
          errors.installment1Amount || "Each installment must be > 0";
      }
      if (i1 + i2 !== total) {
        errors.installment2Amount = `Sum of 2 installments must equal ${total}`;
      }
      if (
        createSubsFormData.installment1Date &&
        createSubsFormData.installment2Date &&
        createSubsFormData.installment2Date <= createSubsFormData.installment1Date
      ) {
        errors.installment2Date = "2nd date must be after 1st";
      }
      // 1st installment mode is required (Cash / Online).
      // Trx id only mandatory when 1st installment is Online — cash auto-uses 'cash'.
      if (!createSubsFormData.installment1Mode) {
        errors.installment1Mode = "1st installment mode required!";
      }
      if (
        createSubsFormData.installment1Mode?.value === "online" &&
        !createSubsFormData.enteredTrxId
      ) {
        errors.enteredTrxId = "Transaction ID required for online payment!";
      }
    }

    if (!createSubsFormData.enteredStartDate) {
      errors.enteredStartDate = "Subscription start date required!";
    }

    if (!createSubsFormData.enteredExpireDate) {
      errors.enteredExpireDate = "Subscription expire date required!";
    }

    if (!createSubsFormData.enteredPrice) {
      errors.enteredPrice = "Price required!";
    }

    return errors;
  };

  const handleAdd = async (payload) => {
    const method = "POST";
    const endpoint = aggrementLink;
    const token = decryptedText?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setCreateSubsModal(false);
        setShowUserInfoForm(false);
        setCurrentStep(1);
        setGstTableValues(initialGstTableValues);
        setCreateSubsFormErrors({});
        setCreateSubsFormData(initialCreateSubsFormData);
        callSubscription();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleAddNewSubscription = async (userData, TOKEN) => {
    setIsSubsFormTrue(false);
    setIsSubmitting(true); // Disable button to prevent double-click
    try {
      const actionResult = dispatch(addNewSubscription({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        const isCashPayment = userData?.trx_id === "cash";

        // Trust the backend's verification flag rather than guessing from
        // the form payload. Backend returns requires_verification=true for
        // any first-touch cash booking (full OR partial 1st installment).
        // On the verified re-submit (cash_verified=true) backend completes
        // the subscription and omits the flag → we land in the else branch.
        if (
          isCashPayment &&
          result?.payload?.requires_verification &&
          result?.payload?.uid
        ) {
          setCashDraftId(result.payload.uid);
          setPendingCashUserData(userData);
          setShowCashQR(true);
          toast.success("Cash request created. Scan QR to verify cash.");
        } else {
          toast.success(result?.payload?.message || "Success!");
          setCreateSubsModal(false);
          setShowUserInfoForm(false);
          setCurrentStep(1);
          setGstTableValues(initialGstTableValues);
          setCreateSubsFormErrors({});
          setCreateSubsFormData(initialCreateSubsFormData);
          callSubscription();
        }
      } else {
        // Backend returns 200 OK with { status:false, message } for business-rule
        // rejections (e.g. PT requires an active regular membership), so the real
        // reason is in payload.message — prefer it over the generic fallback.
        const errorMessage =
          result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleAddNewSubscription ERROR => ", error);
    } finally {
      setIsSubmitting(false); // Re-enable button after API call completes
    }
  };

  // Called when mobile cash verification is complete
  const handleCashVerified = async (verificationToken, verificationData) => {
    if (!pendingCashUserData) return;

    const TOKEN = decryptedText?.token;

    // Re-submit with cash_verified flag to skip approval
    const verifiedUserData = {
      ...pendingCashUserData,
      cash_verified: true,
      cash_verification_token: verificationToken,
      cash_draft_id: cashDraftId,
    };

    try {
      const actionResult = dispatch(
        addNewSubscription({ userData: verifiedUserData, TOKEN })
      );
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success("Subscription created successfully!");
        setCreateSubsModal(false);
        setShowUserInfoForm(false);
        setShowCashQR(false);
        setCashDraftId(null);
        setPendingCashUserData(null);
        setCurrentStep(1);
        setGstTableValues(initialGstTableValues);
        setCreateSubsFormErrors({});
        setCreateSubsFormData(initialCreateSubsFormData);
        callSubscription();
      } else {
        toast.error(result?.payload?.message || "Failed to create subscription");
      }
    } catch (error) {
      console.error("Error creating verified cash subscription:", error);
      toast.error("Error creating subscription. Please try again.");
    }
  };

  useEffect(() => {
    // For single-gym users (gym owner / trainer / receptionist) auto-lock
    // selectedGym to their own gym. Gym owners have users.uid == gym_id and
    // users.gym_id is often NULL — fall back through gym_id → uid → user_id
    // so the field always resolves to a usable gym_id at submit time. Label
    // falls back to user.name when gym_name is missing (gym owner case).
    setCreateSubsFormData((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isManagerRole
        ? {
            label: decryptedText?.gym_name || decryptedText?.name || "",
            value:
              decryptedText?.gym_id ||
              decryptedText?.uid ||
              decryptedText?.user_id ||
              "",
          }
        : "",
    }));
  }, [
    decryptedText?.gym_id,
    decryptedText?.uid,
    decryptedText?.user_id,
    decryptedText?.gym_name,
    decryptedText?.name,
  ]);

  useEffect(() => {
    if (createSubsFormData.enteredPrice) {
      // GST CALCULATION
      const calculateCGSTSGST = (amount) => {
        const preGst = amount / 1.18;
        const gstAmount = preGst * 0.18;
        const total = gstAmount / 2;
        return total.toFixed(2) || 0;
      };

      const calculatePreGST = (amount) => {
        const preGst = amount / 1.18;
        return preGst.toFixed(2) || 0;
      };

      const calculateGST = (amount) => {
        const preGst = amount / 1.18;
        const gstAmount = preGst * 0.18;
        return gstAmount.toFixed(2) || 0;
      };

      const calculateTotalAmount = (amount) => {
        const preGst = amount / 1.18;
        const gstAmount = preGst * 0.18;
        const total = preGst + gstAmount;
        return total.toFixed(2) || 0;
      };
      // --------------- GST CALCULATION ------------------

      const amount = createSubsFormData.enteredPrice;
      const taxableAmount = calculatePreGST(amount);
      const sgst = calculateCGSTSGST(amount);
      const cgst = calculateCGSTSGST(amount);
      const totalAmount = calculateTotalAmount(amount);
      const taxAmount = calculateGST(amount);

      setGstTableValues({
        ...gstTableValues,
        amount,
        taxableAmount,
        sgst,
        cgst,
        totalAmount,
        taxAmount,
      });
    }
  }, [createSubsFormData.enteredPrice]);

  useEffect(() => {
    if (isSubsFormTrue && Object.keys(createSubsFormErrors)?.length === 0) {
      const trxModeValue = createSubsFormData.selectedTrxMode?.value;
      const isDual = trxModeValue === "dual";
      const isPartialMode = trxModeValue === "partial";
      const cashAmt = parseFloat(createSubsFormData.cashAmount) || 0;
      const onlineAmt = parseFloat(createSubsFormData.onlineAmount) || 0;
      const dualTrxId = onlineAmt > 0 ? createSubsFormData.enteredTrxId : "cash";
      // For Partial mode the trx_id comes from the explicit 1st-installment
      // mode dropdown: "cash" → literal 'cash', "online" → user-entered trx id.
      // Defensive fallback to 'cash' if mode wasn't picked (validation should
      // have already blocked submit in that case).
      const resolvedTrxId = isDual
        ? dualTrxId
        : isPartialMode
        ? createSubsFormData.installment1Mode?.value === "online"
          ? createSubsFormData.enteredTrxId
          : "cash"
        : trxModeValue === "online"
        ? createSubsFormData.enteredTrxId
        : trxModeValue || "";
      const resolvedIsPartial = isPartialMode ? 1 : 0;
      const resolvedIsFull = isDual || isPartialMode ? 0 : 1;
      // partial_details captures the cash/online split that goes into the
      // partial_details table. Dual mode uses cashAmount/onlineAmount inputs
      // directly. Partial mode derives the split from the 1st installment
      // mode + amount (whole 1st installment is either cash OR online).
      const installment1AmtNum =
        parseFloat(createSubsFormData.installment1Amount) || 0;
      const partialDetails = isDual
        ? {
            cash_amount: String(cashAmt),
            online_amount: String(onlineAmt),
          }
        : isPartialMode
        ? {
            cash_amount:
              createSubsFormData.installment1Mode?.value === "cash"
                ? String(installment1AmtNum)
                : "0",
            online_amount:
              createSubsFormData.installment1Mode?.value === "online"
                ? String(installment1AmtNum)
                : "0",
          }
        : undefined;

      // Legacy 3-installment schedule — only for Partial mode.
      // Dates are formatted to match backend expectation (DD-MM-YYYY).
      const formatInstallmentDate = (d) =>
        d ? moment(d)?.tz("Asia/Kolkata")?.format("DD-MM-YYYY") : "";
      const installmentPayments = isPartialMode
        ? [
            {
              amount: createSubsFormData.installment1Amount || "0",
              date: formatInstallmentDate(createSubsFormData.installment1Date),
            },
            {
              amount: createSubsFormData.installment2Amount || "0",
              date: formatInstallmentDate(createSubsFormData.installment2Date),
            },
          ]
        : undefined;

      const payloadTypeVal = createSubsFormData.selectedType?.value;
      const payloadIsAddonLike =
        payloadTypeVal === "addon" || payloadTypeVal === "addon_pt";

      const userData = {
        is_web: 1,
        gym_id: createSubsFormData.selectedGym?.value || "",
        user_id: createSubsFormData.selectedUser?.value || "",
        type: createSubsFormData.isPT
          ? "addon_pt"
          : createSubsFormData.selectedType?.value,
        price: createSubsFormData.enteredPrice || "",
        plan_id:
          payloadTypeVal === "regular"
            ? createSubsFormData.selectedPlan?.value
            : payloadIsAddonLike
            ? createSubsFormData.selectedPlan?.value
            : "",
        lead_source: createSubsFormData.selSourceName?.value || "",
        is_partial: resolvedIsPartial,

        req_body: {
          gym_id: createSubsFormData.selectedGym?.value || "",
          user_id: createSubsFormData.selectedUser?.value || "",
          price: createSubsFormData.enteredPrice || "",
          final_price: createSubsFormData.enteredPrice || "",
          trx_id: resolvedTrxId,
          is_full: resolvedIsFull,
          ...(partialDetails ? { partial_details: partialDetails } : {}),
          ...(installmentPayments ? { payment: installmentPayments } : {}),
          trx_status: "done",
          tax_percentage: "18",
          tax_amount: gstTableValues.taxAmount || 0,
          type: createSubsFormData.isPT
            ? "addon_pt"
            : createSubsFormData.selectedType?.value,
          order_status: "done",
          slot_id:
            payloadIsAddonLike && createSubsFormData.selectedSlotID
              ? createSubsFormData.selectedSlotID
              : "",
          addon: payloadIsAddonLike
            ? createSubsFormData.selectedPlan?.value
            : "",
          start_date: createSubsFormData.enteredStartDate
            ? moment(createSubsFormData.enteredStartDate)
                ?.tz("Asia/Kolkata")
                ?.format("DD-MM-YYYY")
            : "",
          expire_date: createSubsFormData.enteredExpireDate
            ? moment(createSubsFormData.enteredExpireDate)
                ?.tz("Asia/Kolkata")
                ?.format("DD-MM-YYYY")
            : "",
          coupon: "",
          plan_id:
            createSubsFormData.selectedType?.value === "regular"
              ? createSubsFormData.selectedPlan?.value
              : "",
          remark: resolvedTrxId,
          event_id: "",
          order_id: "",
          session_id: payloadIsAddonLike
            ? createSubsFormData.selectedSession?.value
            : "",
          trainer_id:
            payloadIsAddonLike && createSubsFormData.selectedTrainer?.value
              ? createSubsFormData.selectedTrainer.value
              : "",
          is_goal: 0,
          is_partial: resolvedIsPartial,
          isWhatsapp: true,
          lead_source: createSubsFormData.selSourceName?.value || "",
          // Send the actual extend days so the membership expiry includes them
          // (was hardcoded 0, which dropped the user-entered extension).
          extend_day: parseInt(createSubsFormData.extendDays) || 0,
          extend_days: parseInt(createSubsFormData.extendDays) || 0,
          payment_date: createSubsFormData.paymentDate
            ? moment(createSubsFormData.paymentDate)
                ?.tz("Asia/Kolkata")
                ?.format("DD-MM-YYYY")
            : "",
        },
      };

      const userDataOLD = {
        gym_id: createSubsFormData.selectedGym?.value || "",
        user_id: createSubsFormData.selectedUser?.value || "",
        price: createSubsFormData.enteredPrice || "",
        final_price: createSubsFormData.enteredPrice || "",
        trx_id: resolvedTrxId,
        is_full: resolvedIsFull,
        ...(partialDetails ? { partial_details: partialDetails } : {}),
        trx_status: "done",
        req_body: installmentPayments
          ? {
              payment: installmentPayments,
              partial_details: partialDetails,
            }
          : partialDetails
          ? { partial_details: partialDetails }
          : undefined,
        tax_percentage: "18",
        tax_amount: gstTableValues.taxAmount || 0,
        type: createSubsFormData.isPT
          ? "addon_pt"
          : createSubsFormData.selectedType?.value,
        order_status: "done",
        slot_id:
          payloadIsAddonLike && createSubsFormData.selectedSlotID
            ? createSubsFormData.selectedSlotID
            : "",
        addon: payloadIsAddonLike
          ? createSubsFormData.selectedPlan?.value
          : "",
        start_date: createSubsFormData.enteredStartDate
          ? moment(createSubsFormData.enteredStartDate)
              ?.tz("Asia/Kolkata")
              ?.format("DD-MM-YYYY")
          : "",
        expire_date: createSubsFormData.enteredExpireDate
          ? moment(createSubsFormData.enteredExpireDate)
              ?.tz("Asia/Kolkata")
              ?.format("DD-MM-YYYY")
          : "",
        coupon: "",
        plan_id:
          payloadTypeVal === "regular"
            ? createSubsFormData.selectedPlan?.value
            : "",
        remark: resolvedTrxId,
        event_id: "",
        order_id: "",
        session_id: payloadIsAddonLike
          ? createSubsFormData.selectedSession?.value
          : "",
        trainer_id:
          payloadIsAddonLike && createSubsFormData.selectedTrainer?.value
            ? createSubsFormData.selectedTrainer.value
            : "",
        is_goal: 0,
        is_partial: resolvedIsPartial,
        isWhatsapp: true,
        lead_source: createSubsFormData.selSourceName?.value || "",
        // userDataOLD is the payload actually dispatched (handleAddNewSubscription).
        // Send the real extend days so the backend's expire computation includes
        // them (was hardcoded 0).
        extend_day: parseInt(createSubsFormData.extendDays) || 0,
        extend_days: parseInt(createSubsFormData.extendDays) || 0,
        payment_date: createSubsFormData.paymentDate
          ? moment(createSubsFormData.paymentDate)
              ?.tz("Asia/Kolkata")
              ?.format("DD-MM-YYYY")
          : "",
      };

      const handleConfirm = async () => {
        // Reset the trigger flag right away so a future submit (after the
        // API completes or fails) re-fires this effect cleanly. Without
        // this, isSubsFormTrue stays true and a 2nd click of Add
        // Subscription becomes a no-op (state already true → no re-render).
        setIsSubsFormTrue(false);
        handleAddNewSubscription(userDataOLD, decryptedText?.token);
        // handleAdd(userData);
      };

      // showConfirmAlert(
      //   handleConfirm,
      //   `An agreement link will be sent to the customer for approval first. Once the approval is done, a payment link will be sent to the customer. For cash payments, a cash approval link will be sent to the front desk or the currently logged-in user.`,
      //   "No, Edit Form!",
      //   "Yes, proceed!"
      // );

      // 6th arg is handleCancel (see ReactAlert.js) — called when the user
      // clicks "No, Edit Form!". Must reset isSubsFormTrue so the next
      // click on Add Subscription re-triggers this effect; otherwise the
      // button looks dead because setIsSubsFormTrue(true) is a no-op when
      // the value is already true.
      showConfirmAlert(
        handleConfirm,
        `Are your sure you want to add this subscription ?`,
        "No, Edit Form!",
        "Yes, Submit!",
        false,
        () => setIsSubsFormTrue(false)
      );
    } else {
      setIsSubsFormTrue(false);
    }
  }, [isSubsFormTrue]);

  return (
    <>
      {/* 2-Step Subscription Modal */}
      <Modal
        isOpen={showUserInfoForm}
        onRequestClose={onCloseUserInfoModal}
        contentLabel="Add New Subscription"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title={currentStep === 1 ? "Add New Subscription - Enter Mobile" : "Add New Subscription"}
            onClose={onCloseUserInfoModal}
          />

          {showCashQR && cashDraftId ? (
            <div style={{ padding: "20px" }}>
              <CashVerificationQR
                cashDraftId={cashDraftId}
                onVerified={handleCashVerified}
              />
            </div>
          ) : (
            <SubscriptionUserDetails
              decryptedText={decryptedText}
              createSubsFormData={createSubsFormData}
              setCreateSubsFormData={setCreateSubsFormData}
              createSubsFormErrors={createSubsFormErrors}
              gstTableValues={gstTableValues}
              onClickSubmit={onClickSubmit}
              isSubmitting={isSubmitting}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
            />
          )}
        </div>
      </Modal>

      <CommonStructured
        pageHeading={"Subscriptions"}
        createBtnTxt={"+ Add New Subscriptions"}
        onClickCreateBtn={onOpenSubscriptionModal}
        onClickReset={onClickReset}
        isReload={callSubscription}
      />
    </>
  );
};

export default SubscriptionPageStructure;
